import React from 'react';
import classNames from 'classnames';
import { Loading } from '../../svg';
import { useTranslation } from 'react-i18next';

type LoaderProps = {
  className?: string,
  shouldFocus?: boolean,
  a11y?: string,
  small?: boolean
};

export const Loader = ({ className, shouldFocus, a11y, small }: LoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('loader', { 'loader--small': small }, className)} role='alert'>
      <Loading />
      <span
        className={classNames('loader__text', { 'sr-only': small })}
        tabIndex={-1}
        ref={(ref) => shouldFocus && ref?.focus()}
      >
        {t('loading')}
        {a11y && <span className='sr-only'>{a11y}</span>}
      </span>
    </div>
  );
};
